module.exports = __webpack_public_path__ + "img/v4_flowerQuery_h.b821c438.png";